// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["./style-blocks"], () => (__webpack_require__("./blocks/index.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["./style-blocks"], () => (__webpack_require__("./blocks/scss/style.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
